import React from "react";

export function OverviewIcon(props) {
  const { height = "24", width = "24", color = "#EBEBEB" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 21V9l8-6 8 6v12h-6v-7h-4v7H4z" fill={color} />
    </svg>
  );
}
